<template>
  <section class="main-content ">
    <MainBanner banner="Jobs.Single" :linkParam="formlink" />
    <script type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Startseite - ito consult GmbH",
            "item": "https://ito-consult.de"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Über uns",
            "item": "https://ito-consult.de/jobs"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "{{job.title}}",
            "item": "https://ito-consult.de/jobs/{{job.slug}}"
          }
        ]
      }
    </script>
    <section class="block-content mb-5">
      <div class="container my-5 py-5">
        <div
          class="content-midwide"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-offset="100"
        >
          <h2>{{ job.title }}</h2>
          <article class="d-content" v-html="job.description"></article>
          <router-link
            title="Jetzt bewerben!"
            v-if="job.slug"
            :to="{ name: 'job.form' }"
            class="btn btn-outline-ito stretched-link hover-red animated-arrow mt-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"
              ></path>
            </svg>
            Bewirb dich jetzt
          </router-link>
        </div>
      </div>
    </section>
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
  </section>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import router from '@/router'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'JobSingle',
  data: function () {
    return {
      job: {}
    }
  },
  computed: {
    job_id: function () {
      return this.$route.params.id
    },
    formlink: function () {
      return '/jobs/' + this.job.slug + '/form'
    }
  },
  methods: {
    jobDate: function (d) {
      const today = new Date()
      const jobentry = new Date(d)

      return today > jobentry
        ? 'ab sofort'
        : ('0' + jobentry.getDate()).slice(-2) +
            '.' +
            ('0' + (jobentry.getMonth() + 1)).slice(-2) +
            '.' +
            jobentry.getFullYear()
    }
  },
  async beforeMount () {
    await axios.get('/jobs?filter[slug]=' + this.job_id).then(response => {
      if (response.data.data.length > 0) {
        this.job = response.data.data[0]
        store.commit('loadingStatus', false)
      } else {
        // Falls slug in directus nicht vorhanden, 404 Umleitung
        router.replace({ name: '404' })
      }
    })
  },
  components: {
    MainBanner
  }
}
</script>
<style scoped>
.slide-leave-active,
.slide-enter-active {
  transition: 400ms;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
</style>
